export const tableUnitHeader = [
    { key: "number", value: "№"},
    { key: "name", value: "Название"},
    { key: "count", value: "Количество объектов"},
    { key: "description", value: "Описание подразделения"},
];
